import { render, staticRenderFns } from "./storyData.vue?vue&type=template&id=42a57864&"
import script from "./storyData.vue?vue&type=script&lang=js&"
export * from "./storyData.vue?vue&type=script&lang=js&"
import style0 from "./storyData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports